module.exports = __webpack_public_path__ + "img/logout.6bd67684.svg";